<div class="grid">

    <div class="col-12">

        <!-- <p-card header="Clickthroughs - Details" subheader="" class="tile" > -->

        <p-card subheader="" class="wal-tile">

            <ng-template pTemplate="header">
                <div class="custom-card-header">
                    <div class="header-text">Clickthrough Events</div>

                    @if(isSummaryShown) {
                        
                        <!--  C R I T E R I A  -->

                        <div class="header-controls">
                            <div class="field grid m-0 align-items-center">
                                <label for="aggregationType" class="mr-2 mb-0" style="width: 11em">
                                    Aggregation Type: 
                                </label>
                                <div style="width: 150px;"> 
                                    <p-select 
                                        id="aggregationType" 
                                        [options]="aggregationTypes" 
                                        [(ngModel)]="aggregationType" 
                                        (ngModelChange)="onAggregationTypeChanged($event)"
                                        [style]="{'width': '100%'}">
                                    </p-select>
                                </div>
                            </div>
                        </div>                    
                    }
                </div>

            </ng-template>

            <!--  G R I D  -->

            @if(isSummaryShown) {
                <div class="ng-template w-full">

                    <div class="grid">

                        <div class="col-5">

                            <p-table #dtt [columns]="summaryColumns" [value]="summaryRows" selectionMode="single"
                                class="wal-table"
                                tableStyleClass="prime-table" [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true"
                                sortMode="multiple" [paginator]="true" [rows]="15">
                                <ng-template pTemplate="caption">
                                Clickthrough Counts by Link Type and Platform
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                <tr>
                                @for (col of columns; track col.field) {
                                    <th [pSortableColumn]="col.field"
                                        [style.display]="col.display"
                                        [style.width]="col.width">
                                        {{ col.header }}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                }
                                </tr>
                                </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr [pSelectableRow]="rowData">
                                        @for (col of columns; track col.field) {
                                            <td [style.width]="col.width" [style.display]="col.display">
                                                {{ rowData[col.field] }}
                                            </td>
                                        }
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div style="text-align:left">
                                        <p-button type="button" label="CSV Export"
                                            styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="dtt.exportCSV()">
                                        </p-button>
                                        <p-button type="button" label="PDF Export"
                                            styleClass="p-button-warning p-button-raised p-button-rounded margin-left" (click)="exportToPdf()">
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-table> 
                            
                        </div>

                        <div class="col-1"></div>

                        <div class="col-5 chart-col">
                            @if(tabValue === 'Summary' && hasData) {

                                @defer (on viewport) {
                                    <p-chart [type]="selectedChartType"
                                        #chart
                                        [data]="chartData"
                                        [options]="chartOptions"
                                        class="wal-chart-container">
                                    </p-chart>
                                } @placeholder {
                                    <div>Loading chart...</div>
                                } @error {
                                    <p>Failed to load the chart.</p>
                                }
                                
                            }
                        </div>
                    </div>                            

                </div>
            }   

            @if(isDetailsShown) {
                <div class="ng-template w-full">

                    <div class="p-datatable p-component">

                        <div class="p-datatable-header">
                            <div class="header-row">
                            <div class="wal-page-title">Clickthrough Details</div>
                            </div>
                        </div>                            

                        <div class="p-datatable-wrapper">

                            <!-- Column headers with sorting -->
                            <div class="thead row-grid">
                                <div class="th clickable" (click)="toggleSort('clickthroughId')">
                                    Event ID <span>{{ sortField === 'clickthroughId' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('passName')">
                                    Pass Name <span>{{ sortField === 'passName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('linkName')">
                                    Link Name <span>{{ sortField === 'linkName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <!-- <div class="th clickable" (click)="toggleSort('source')">
                                    Source <span>{{ sortField === 'source' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('clickType')">
                                    Click Type <span>{{ sortField === 'clickType' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div> -->
                                <div class="th clickable" (click)="toggleSort('platform')">
                                    Platform <span>{{ sortField === 'platform' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('linkCategory')">
                                    Link Category <span>{{ sortField === 'linkCategory' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('createDate')">
                                    Create Date <span>{{ sortField === 'createDate' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                            </div>

                            <!-- Scrollable viewport -->
                            <div class="tbody-viewport">
                                @if (datasource) {
                                    <!-- Virtualized rows -->
                                    <div
                                    class="tr row-grid"
                                    *uiScroll="let row of datasource; let even = even"
                                    (click)="onRowClick(row)"
                                    [class.even]="even"
                                    [class.selected]="isSelected(row)"
                                    >
                                        <div class="td">{{ row.clickthroughId }}</div>
                                        <div class="td">{{ row.passName }}</div>
                                        <div class="td">{{ row.linkName }}</div>
                                        <!-- <div class="td">{{ row.source }}</div>
                                        <div class="td">{{ row.clickType }}</div> -->
                                        <div class="td">{{ row.platform }}</div>
                                        <div class="td">{{ row.linkCategory }}</div>
                                        <div class="td">{{ row.createDate }}</div>
                                    </div>
                                }
                            </div>

                        </div>

                        <div class="p-datatable-footer p-text-secondary">
                        </div>

                    </div>    

                </div>
            }   

        </p-card>

    </div>

</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="client-dashboard-warning"></p-confirmDialog>







